import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderFreteService {
  private baseUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  private get headers(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'X-GuidCliente': localStorage.getItem('guidclientenapis') || ''
    });
  }

  private get url(): string {
    return this.baseUrl + 'api/Admin/OrderFrete';
  }

  getAll(): Observable<any[]> {
    return this.http.get<any[]>(this.url, { headers: this.headers })
      .pipe(catchError(() => of([])));
  }

  create(dto: any): Observable<any> {
    return this.http.post<any>(this.url, dto, { headers: this.headers });
  }

  update(id: number, dto: any): Observable<any> {
    return this.http.put<any>(`${this.url}/${id}`, dto, { headers: this.headers });
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.url}/${id}`, { headers: this.headers });
  }
}
